export default __webpack_public_path__ + "i18n/ja.6ef41676781588a8874b1320589fe9dc.json";